
import {Component, Vue, Prop} from 'vue-property-decorator';

@Component(
    {
      name: 'catalog-product-configurable-select'
    }
)

export default class extends Vue {
  @Prop() private readonly optionData: object;
  @Prop() private readonly checkEnabled: boolean;
  @Prop() private readonly step: number;

  private selectedValue: number | string = '';
  private attributeOptions: Array<object> = [];

  private async updateCurrentStep(e): Promise<void> {
    await this.$store.dispatch('CatalogConfigurableProduct/setSelectedOption', {
      attributeId: this.optionData['id'],
      attributeCode: this.optionData['code'],
      selectedValue: e.target.value
    });
    await this.$store.dispatch('CatalogConfigurableProduct/updateStep', (this.step + 1));
  }

  private async getProductOptions(): Promise<Array<object>> {
    return await this.$store.dispatch('CatalogConfigurableProduct/getAttributeOptionsByCode', this.optionData['code']).then(r => this.attributeOptions = r);
  }

  private get orderedAttributeOptions(): object[] {
    return this.optionData['options'].map((o: any) => {
      o.option = (this.attributeOptions[o['label']] || [])[0] || null
      return o
    }).filter((o: any) => null !== o['option'])
  }

  private get productFinalPrice(): number {
    return this.$store.getters['CatalogProduct/totalPrices']['totalPriceInclTax'];
  }

  private get showAdditionalPrice(): boolean {
    return this.$store.getters['CatalogConfigurableProduct/availableAttributes'].length === (this.step + 1);
  }

  private async created(): Promise<void> {
    await this.getProductOptions();
    const productOptions = Object.keys(this.attributeOptions).map(o => this.attributeOptions[o][0]);
    if (productOptions.length === 1) {
      this.selectedValue = productOptions[0][`${this.optionData['code']}_option_id`];
      await this.$store.dispatch('CatalogConfigurableProduct/setSelectedOption', {attributeId: this.optionData['id'], attributeCode: this.optionData['code'], selectedValue: productOptions[0][`${this.optionData['code']}_option_id`]});
      await this.$store.dispatch('CatalogConfigurableProduct/updateStep', (this.step + 1));
    }
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'CatalogConfigurableProduct/UPDATE_CURRENT_STEP') {
        if (this.step >= state['CatalogConfigurableProduct'].step) {
          this.selectedValue = '';
          this.getProductOptions();
        }
      }
    });
  }
}
